module.exports = __webpack_public_path__ + "static/media/savvy-ipfs-share-files.640bb55b.svg";